var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { color: "transparent", "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tabs-slider", { attrs: { color: "primary" } }),
          _vm._v(" "),
          _vm._l(_vm.tabs, function(tabItem) {
            return _c("v-tab", { key: tabItem }, [
              _vm._v("\n        " + _vm._s(tabItem) + "\n      ")
            ])
          }),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              attrs: { touchless: "" },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            _vm._l(2, function(item, index) {
              return _c(
                "v-tab-item",
                { key: "item" + index },
                [
                  index === 0
                    ? _c(
                        "v-container",
                        { attrs: { fluid: "", "grid-list-lg": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { dark: "", color: "primary" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.showDestinationAddDialog.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("addDestination")))]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-list",
                                _vm._l(_vm.destinations, function(item) {
                                  return _c(
                                    "v-list-group",
                                    {
                                      key: item.title,
                                      attrs: {
                                        "prepend-icon": "local_offer",
                                        "no-action": ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "v-list-tile",
                                                  [
                                                    _c(
                                                      "v-list-tile-content",
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-anchor"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              _vm._s(item.name)
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: item.active,
                                        callback: function($$v) {
                                          _vm.$set(item, "active", $$v)
                                        },
                                        expression: "item.active"
                                      }
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        {
                                          staticStyle: {
                                            "background-color":
                                              "rgb(230, 230, 230)"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(_vm._s(item.content))
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c(
                                                "v-layout",
                                                [
                                                  _c(
                                                    "v-flex",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            fab: "",
                                                            small: "",
                                                            flat: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.showDestinationEditDialog(
                                                                item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v("edit")
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            fab: "",
                                                            small: "",
                                                            flat: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.deleteDestination(
                                                                item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v("delete")
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.destinationAddDialog
                            ? _c("DestinationEdit", {
                                attrs: {
                                  title: _vm.$t("addDestination"),
                                  actionFunc: _vm.addDestination,
                                  actionText: _vm.$t("add"),
                                  destination: _vm.destinationInEdit
                                },
                                model: {
                                  value: _vm.destinationAddDialog,
                                  callback: function($$v) {
                                    _vm.destinationAddDialog = $$v
                                  },
                                  expression: "destinationAddDialog"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.destinationEditDialog
                            ? _c("DestinationEdit", {
                                attrs: {
                                  title: _vm.$t("editDestination"),
                                  actionFunc: _vm.editDestination,
                                  destination: _vm.destinationInEdit
                                },
                                model: {
                                  value: _vm.destinationEditDialog,
                                  callback: function($$v) {
                                    _vm.destinationEditDialog = $$v
                                  },
                                  expression: "destinationEditDialog"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  index === 1
                    ? _c(
                        "v-container",
                        { attrs: { fluid: "", "grid-list-lg": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { dark: "", color: "primary" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.showInstructionAddDialog.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("addInstructions")))]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-list",
                                _vm._l(_vm.instructions, function(item) {
                                  return _c(
                                    "v-list-group",
                                    {
                                      key: item.title,
                                      attrs: {
                                        "prepend-icon": "local_offer",
                                        "no-action": ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "v-list-tile",
                                                  [
                                                    _c(
                                                      "v-list-tile-content",
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-anchor"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              _vm._s(item.name)
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: item.active,
                                        callback: function($$v) {
                                          _vm.$set(item, "active", $$v)
                                        },
                                        expression: "item.active"
                                      }
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        {
                                          staticStyle: {
                                            "background-color":
                                              "rgb(230, 230, 230)"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(_vm._s(item.content))
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c(
                                                "v-layout",
                                                [
                                                  _c(
                                                    "v-flex",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            fab: "",
                                                            small: "",
                                                            flat: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.showInstructionEditDialog(
                                                                item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v("edit")
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            fab: "",
                                                            small: "",
                                                            flat: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.deleteInstruction(
                                                                item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v("delete")
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.instructionAddDialog
                            ? _c("DestinationEdit", {
                                attrs: {
                                  title: _vm.$t("addInstruction"),
                                  actionFunc: _vm.addInstruction,
                                  actionText: _vm.$t("add"),
                                  destination: _vm.instructionInEdit
                                },
                                model: {
                                  value: _vm.instructionAddDialog,
                                  callback: function($$v) {
                                    _vm.instructionAddDialog = $$v
                                  },
                                  expression: "instructionAddDialog"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.instructionEditDialog
                            ? _c("DestinationEdit", {
                                attrs: {
                                  title: _vm.$t("editInstruction"),
                                  actionFunc: _vm.editInstruction,
                                  destination: _vm.instructionInEdit
                                },
                                model: {
                                  value: _vm.instructionEditDialog,
                                  callback: function($$v) {
                                    _vm.instructionEditDialog = $$v
                                  },
                                  expression: "instructionEditDialog"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-101076de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-101076de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shipping.vue
// module id = null
// module chunks = 